import React, { useState, useEffect, PureComponent } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Space,
  Button,
  Dropdown,
  Row,
  Col,
  Input,
  Form,
  DatePicker,
  Radio,
  Select,
  Card,
  Popover,
  QRCode,
  Empty,
  Avatar,
} from "antd";
import {
  QrcodeOutlined,
  MoreOutlined,
  UserAddOutlined,
  ControlOutlined,
  FileExcelOutlined,
  PrinterOutlined,
  CheckOutlined,
  DownOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import patientimg from "../../patient.jpg";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import QRCodeGenerator from "../CommonComponents/QRCodeGenerator";
import logo from "../../logo.png";
import { getRecentVisitsApi } from "./DashboardAPI";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import HealthScore from "../CommonComponents/HealthScore";

function ChyroDashboard() {
  const intl = useIntl();
  const { Option } = Select;
  const dispatch = useDispatch();
  const RecentVisitsData = useSelector(
    (state) => state.dashboard.PatientListRecords
  );
  const totalPages = useSelector((state) => state.dashboard.totalPages);
  const { Column, ColumnGroup } = Table;
  const { Search } = Input;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrCodeValues, setQRCodeValues] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [healthStatus, setHealthStatus] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [value, setValue] = useState(1);
  const onChange = (e) => {
    setValue(e.target.value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const handleRedirect = (PatientId) => {
    navigate(`/patients/viewpatient/${PatientId}`, {
      state: { from: "dashboard" },
    });
  };

  const input = {
    pageNo: currentPage,
    pageSize: 10,
    searchQuery: searchTerm,
    healthStatus: healthStatus,
  };
  // const filterByHealthStatus = (status) => {
  //   setHealthStatus(status);
  //   setCurrentPage(1);

  //   if (status === "All") {
  //     setFilteredData(RecentVisitsData);
  //     return;
  //   }

  //   const filtered = RecentVisitsData.filter((item) => {
  //     const score = item.healthscore;
  //     if (status === "Healthy") return score >= 8;
  //     if (status === "Average") return score >= 6 && score < 8;
  //     if (status === "Serious") return score >= 1 && score < 6;
  //     return false;
  //   });

  //   setFilteredData(filtered);
  // };

  useEffect(() => {
    dispatch(getRecentVisitsApi(input));
  }, [dispatch, currentPage, searchTerm, healthStatus]);
  useEffect(() => {
    setFilteredData(RecentVisitsData); // sync after fetch
  }, [RecentVisitsData]);
  const healthOptions = [
    { key: "", value: <FormattedMessage id="HealthStatusFilter.All" /> },
    {
      key: "Healthy",
      value: <FormattedMessage id="HealthStatusFilter.Healthy" />,
    },
    {
      key: "Average",
      value: <FormattedMessage id="HealthStatusFilter.Average" />,
    },
    {
      key: "Serious",
      value: <FormattedMessage id="HealthStatusFilter.Serious" />,
    },
  ];

  const healthMenuItems = healthOptions.map(({ key, value }) => ({
    key, // used for selection and API call
    label: (
      <Space>
        {key === healthStatus && <CheckOutlined />}
        {value}
      </Space>
    ),
    style: {
      backgroundColor: key === healthStatus ? "#336899" : undefined,
      color: key === healthStatus ? "#fff" : undefined,
    },
  }));
  const selectedHealthLabel =
    healthOptions.find((option) => option.key === healthStatus)?.value ||
    intl.formatMessage({ id: "ChyroDashboard.HealthStatuses" }) ||
    "Health Statuses";
  const handleHealthFilter = ({ key }) => {
    //filterByHealthStatus(key);
    setHealthStatus(key);
  };
  return (
    <>
      <div className="feature-view">
        <div className="title-heading">
          <h2>
            <FormattedMessage id="Common.Dashboard" />
          </h2>
          <p>
            <FormattedMessage id="ChyroDashboard.Description" />
          </p>
        </div>

        <Card className="mt-24">
          <div className="table-top">
            <Row gutter={16} justify="space-between">
              <Col flex="1" className="text-right">
                <Search
                  size="large"
                  placeholder={intl.formatMessage({
                    id: "ChyroDashboard.Searchbypatientname",
                  })}
                  allowClear
                  style={{ width: "100%" }}
                  onSearch={handleSearch}
                />
              </Col>
              <Col>
                <Dropdown
                  menu={{
                    items: healthMenuItems,
                    onClick: handleHealthFilter,
                  }}
                >
                  <Button onClick={(e) => e.preventDefault()} size="large">
                    <Space>
                      {selectedHealthLabel}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Col>
            </Row>
          </div>
        </Card>
        <Card className="no-padding-card mt-24" variant="borderless">
          <Table
            className="patientlisttable"
            dataSource={filteredData}
            bordered
            scroll={{
              x: 1000,
            }}
            pagination={{
              current: currentPage,
              total: totalPages * 10,
              onChange: handlePageChange,
            }}
            locale={{
              emptyText: (
                <Empty
                  image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                  imageStyle={{
                    height: 80,
                  }}
                  description={intl.formatMessage({ id: "Common.NoData" })}
                />
              ),
            }}
          >
            <Column
              title={<FormattedMessage id="PatientList.PatientName" />}
              dataIndex="patientname"
              key="patientname"
              render={(_, record) => (
                <div
                  onClick={() => handleRedirect(record.patientId)}
                  style={{
                    display: "flex",
                    alignItems: "start",
                    cursor: "pointer", // to show it's clickable
                  }}
                >
                  <Avatar
                    style={{
                      backgroundColor: "#336899",
                      textTransform: "uppercase",
                    }}
                    size="large"
                  >
                    {record.firstName[0]}
                    {record.lastName[0]}
                  </Avatar>
                  <Space direction="vertical" style={{ marginLeft: 8 }}>
                    <div
                      style={{ fontWeight: 600, textTransform: "capitalize" }}
                    >
                      {record.firstName} {record.lastName}
                    </div>
                    <div style={{ color: "#888" }}>ID: {record.userId}</div>
                  </Space>
                </div>
              )}
            />

            <Column
              title={<FormattedMessage id="PatientList.VisitId" />}
              dataIndex="patientVisitId"
              key="patientVisitId"
            />
            <Column
              title={<FormattedMessage id="ChyroDashboard.VisitDate" />}
              key="timedate"
              render={(_, record) => (
                <Space size="small">
                  {moment(record?.patientVisitedDate).format(
                    "DD-MMM-YYYY  HH:mm"
                  )}
                </Space>
              )}
            />
            <Column
              title={<FormattedMessage id="Clients.Weight" />}
              dataIndex="totalBodyWeight"
              key="totalBodyWeight"
            />
            <Column
              title={<FormattedMessage id="ViewPatient.BMI" />}
              dataIndex="bmi"
              key="bmi"
            />
            <Column
              title={<FormattedMessage id="ViewPatient.BMR" />}
              dataIndex="bmr"
              key="bmr"
            />
            <Column
              title={<FormattedMessage id="PatientList.Age" />}
              dataIndex="age"
              key="age"
            />
            <Column
              title={<FormattedMessage id="PatientList.Gender" />}
              dataIndex="gender"
              key="gender"
            />
            <Column
              title={<FormattedMessage id="ChyroDashboard.HealthScore" />}
              dataIndex="healthscore"
              key="healthscore"
              width={150}
              render={(_, record) => (
                <Space size="middle">
                  <HealthScore record={record.healthscore} />
                </Space>
              )}
            />
          </Table>
        </Card>
      </div>
    </>
  );
}

export default ChyroDashboard;
